import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { IoReload } from "react-icons/io5";
import toast from "react-hot-toast";
import { FaChevronDown, FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";
import Top from "../components/Top";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import { IoIosClose } from "react-icons/io";
import { SlCalender } from "react-icons/sl";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { formatAiScore } from "../utils/aiReport";
import { FaGreaterThanEqual } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import { FaLessThan } from "react-icons/fa6";

const CandidateProgressDashboard = ({ currentUser }) => {
  const [jobTitleFilter, setJobTitleFilter] = useState("");
  const [jobCodeFilter, setJobCodeFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [clientNameFilter, setClientNameFilter] = useState("");
  const [candidateStatusFilter, setCandidateStatusFilter] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [filteredCandidates2, setFilteredCandidates2] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [candidates2, setCandidates2] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loading3, setLoading3] = useState(true);
  const [jobs, setJobs] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [clientNames, setClientNames] = useState([]);
  const [paginatedCandidates, setPaginatedCandidates] = useState([]);
  const [aiReport, setAiReport] = useState({});
  const [aiJobTitle, setAiJobTitle] = useState("");
  const [showReport, setShowReport] = useState(false);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [retryingAiScore, setRetryingAiScore] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [filter, setFilter] = useState();
  const [inactive, setInactive] = useState(0)
  const [allOptions, setAllOptions] = useState([]);
  const [finalOptions, setFinalOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [showJobSelect, setShowJobSelect] = useState(false);
  const [canStatusObj, setCanStatusObj] = useState({});
  const [sortOrder, setSortOrder] = useState("desc")
  const [sortOn, setSortOn] = useState(false)

  const filterThresholds = filter && filter[0] ? filter[0] : { green: 80, amber: 60 };


  const navigate = useNavigate();

  const totalPages = Math.ceil(count / itemsPerPage);
  const today = new Date().toISOString().split("T")[0];

  const fromDateRef = useRef()
  const toDateRef = useRef()
  const jobTitleSRef = useRef()
  const jobToggleRef = useRef()
  const selectedJobRef = useRef()

  const selectRef1 = useRef(null);
  const selectRef2 = useRef(null);
  const selectRef3 = useRef(null);
  const selectRef4 = useRef(null);

  const handleFromDateClick = () => {
    fromDateRef.current.showPicker()
  }

  const handleToDateClick = () => {
    toDateRef.current.showPicker()
  }

  useEffect(() => {
    if (selectedJobRef.current) {
      selectedJobRef.current.scrollIntoView()
    }
  }, [showJobSelect])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showJobSelect && jobTitleSRef.current && !jobTitleSRef.current.contains(event.target) &&
        jobToggleRef.current &&
        !jobToggleRef.current.contains(event.target)) {
        setShowJobSelect(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [showJobSelect])

  useEffect(() => {
    if (candidates.length > 0) {
      setJobTitleFilter(jobTitleFilter || localStorage.getItem("jobTitleValue"))
      setJobCodeFilter(jobCodeFilter || localStorage.getItem("jobCodeValue"))
      setClientNameFilter(clientNameFilter || localStorage.getItem("clientNameValue"))
      setFromDate(fromDate || localStorage.getItem("fromDateValue"))
      setToDate(toDate || localStorage.getItem("toDateValue"))
      setCandidateStatusFilter(candidateStatusFilter || localStorage.getItem("candidateStatusValue"))
      applyFilters(searchValue, jobTitleFilter || localStorage.getItem("jobTitleValue"), jobCodeFilter || localStorage.getItem("jobCodeValue"), clientNameFilter || localStorage.getItem("clientNameValue"), fromDate || localStorage.getItem("fromDateValue"), toDate || localStorage.getItem("toDateValue"), candidateStatusFilter || localStorage.getItem("candidateStatusValue"))
    }
  }, [candidates])

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setCurrentPage(1)
    if (filteredCandidates2.length > 1) {
      setCount(filteredCandidates2.length)
      setPaginatedCandidates(filteredCandidates2.slice(startIndex, endIndex));
    } else {
      setCount(filteredCandidates.length)
      setPaginatedCandidates(filteredCandidates.slice(startIndex, endIndex));
    }
  }, [itemsPerPage]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    if (filteredCandidates2.length > 1) {
      setCount(filteredCandidates2.length)
      setPaginatedCandidates(filteredCandidates2.slice(startIndex, endIndex));
    } else {
      setCount(filteredCandidates.length)
      setPaginatedCandidates(filteredCandidates.slice(startIndex, endIndex));
    }
  }, [currentPage]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    if (filteredCandidates2.length > 1) {
      setCount(filteredCandidates2.length)
      setPaginatedCandidates(filteredCandidates2.slice(startIndex, endIndex));
    } else {
      setCount(filteredCandidates.length)
      setPaginatedCandidates(filteredCandidates.slice(startIndex, endIndex));
    }
  }, [filteredCandidates]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading2(true);
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/create-answers`,
          {
            withCredentials: true
          }
        );
        const data = response.data;
        setFilteredCandidates(data.candidates);
        setPaginatedCandidates(data.candidates);
        setCandidates(data.candidates);

        setCandidates2(data.candidates);
        setCount(data.candidates.length);
        setLoading2(false);
        setClientNames(getUniqueClientNames(data.candidates));
      } catch (error) {
        setLoading2(false);
      }
    };
    fetchData();
  }, [inactive]);

  useEffect(() => {
    if (jobs && candidates) {
      // Create a Map to track unique job codes
      const uniqueJobsMap = new Map();

      // Create a Set of job codes from candidates for quick lookup
      const candidateJobCodes = new Set();
      candidates.forEach((candidate) => {
        if (candidate.job_code) {
          candidateJobCodes.add(candidate.job_code);
        }
      });

      // First, add all jobs from jobs array
      jobs.forEach((job) => {
        if (job.job_code) {
          uniqueJobsMap.set(job.job_code, {
            jobTitle: job.job_title,
            jobCode: job.job_code
          });
        }
      });

      // Then, override with candidate data only if the job_code exists in jobs
      candidates.forEach((candidate) => {
        if (candidate.job_code && uniqueJobsMap.has(candidate.job_code)) {
          uniqueJobsMap.set(candidate.job_code, {
            jobTitle: candidate.job_title,
            jobCode: candidate.job_code
          });
        }
      });

      // Convert Map values to array for finalOptions
      const combinedOptions = Array.from(uniqueJobsMap.values());
      setFinalOptions(combinedOptions);
      setAllOptions(combinedOptions);
    }
  }, [jobs, candidates]);


  useEffect(() => {

    let inactivityTimer;
    const INACTIVITY_TIMEOUT = 60000;

    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        setInactive((prev) => prev + 1)
        handleReset()
      }, INACTIVITY_TIMEOUT);
    };

    const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    activityEvents.forEach(event => {
      window.addEventListener(event, resetInactivityTimer);
    });

    resetInactivityTimer();

    return () => {
      clearTimeout(inactivityTimer);
      activityEvents.forEach(event => {
        window.removeEventListener(event, resetInactivityTimer);
      });
    };
  }, [candidates]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/filter`,
          {
            withCredentials: true
          }
        );
        setFilter(response.data.filter)
        setLoading3(false);
      } catch (error) {
        setLoading3(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/get-all-jobs`,
          {
            withCredentials: true
          }
        );
        const data = response.data.jobs;
        setJobs(data);
      } catch (err) {
        toast.error("Failed to load candidated.")
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  const sortScores = () => {
    const sortedCandidates = [...filteredCandidates].sort((a, b) => {
      // Handle cases where ai_report or percentage might be missing
      const scoreA = Number(a?.ai_report?.percentage) || 0;
      const scoreB = Number(b?.ai_report?.percentage) || 0;
      // Sort in descending order (higher scores first)
      return sortOrder === "desc" ? scoreB - scoreA : scoreA - scoreB;
    });
    setFilteredCandidates(sortedCandidates);
    const sortedCandidates2 = [...filteredCandidates2].sort((a, b) => {
      // Handle cases where ai_report or percentage might be missing
      const scoreA = Number(a?.ai_report?.percentage) || 0;
      const scoreB = Number(b?.ai_report?.percentage) || 0;
      // Sort in descending order (higher scores first)
      return sortOrder === "desc" ? scoreB - scoreA : scoreA - scoreB;
    });
    setFilteredCandidates2(sortedCandidates2);
    const sortedCandidates3 = [...candidates].sort((a, b) => {
      // Handle cases where ai_report or percentage might be missing
      const scoreA = Number(a?.ai_report?.percentage) || 0;
      const scoreB = Number(b?.ai_report?.percentage) || 0;
      // Sort in descending order (higher scores first)
      return sortOrder === "desc" ? scoreB - scoreA : scoreA - scoreB;
    });
    setCandidates(sortedCandidates3);

    setSortOrder(sortOrder === "desc" ? "asc" : "desc")
    setSortOn(true)
  };

  const sortName = () => {
    // Helper function to calculate combined score
    const getCombinedScore = (candidate) => {
      const assessmentScore = candidate?.assessment_score || 0;
      const aiPercentage = candidate?.ai_report?.percentage || 0;
      return assessmentScore + aiPercentage;
    };

    // Sort by combined score (highest first for ranking)
    const sortedCandidates = [...filteredCandidates].sort((a, b) => {
      const scoreA = getCombinedScore(a);
      const scoreB = getCombinedScore(b);
      return sortOrder === "desc" ? scoreB - scoreA : scoreB - scoreA;
    });

    const sortedCandidates2 = [...filteredCandidates2].sort((a, b) => {
      const scoreA = getCombinedScore(a);
      const scoreB = getCombinedScore(b);
      return sortOrder === "desc" ? scoreB - scoreA : scoreB - scoreA;
    });

    const sortedCandidates3 = [...candidates].sort((a, b) => {
      const scoreA = getCombinedScore(a);
      const scoreB = getCombinedScore(b);
      return sortOrder === "desc" ? scoreB - scoreA : scoreB - scoreA;
    });

    setFilteredCandidates(sortedCandidates);
    setFilteredCandidates2(sortedCandidates2);
    setCandidates(sortedCandidates3);
  };

  const handleSearch = (e) => {
    const name = e.target.value;
    const filteredValue = name.replace(/[^a-zA-Z0-9@._\- ]/g, '');

    setSearchValue(filteredValue);
    applyFilters(filteredValue, jobTitleFilter, jobCodeFilter, clientNameFilter, fromDate, toDate, candidateStatusFilter);
  };

  const handleSearch2 = (name) => {
    const filteredValue = name.replace(/[^a-zA-Z0-9@._\- ]/g, '');

    setSearchValue(filteredValue);
    applyFilters(filteredValue, jobTitleFilter, jobCodeFilter, clientNameFilter, fromDate, toDate, candidateStatusFilter);
  };

  const getUniqueClientNames = (candidates) => {
    const uniqueClients = new Set();
    candidates.forEach((candidate) => {
      if (candidate.client_name && !uniqueClients.has(candidate.client_name)) {
        uniqueClients.add(candidate.client_name);
      }
    });
    return Array.from(uniqueClients);
  };

  const applyFilters = (search, jobTitle, jobCode, clientName, fromDate, toDate, candidateStatus) => {
    let filtered = [...candidates];

    if (search) {
      const normalizedSearch = search.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

      filtered = filtered.filter((candidate) => {
        const normalizedName = candidate.name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedEmail = candidate.email.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedApplicantId = candidate.applicant_id.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedJobCode = candidate.job_code.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedJobTitle = candidate.job_title.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedClientName = candidate.client_name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        let normalizedHrStatus = "";
        if (typeof candidate.hr_status === "string") {
          normalizedHrStatus = candidate.hr_status.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        }

        return (
          normalizedName.includes(normalizedSearch) ||
          normalizedEmail.includes(normalizedSearch) ||
          normalizedApplicantId.includes(normalizedSearch) ||
          normalizedJobCode.includes(normalizedSearch) ||
          normalizedJobTitle.includes(normalizedSearch) ||
          normalizedClientName.includes(normalizedSearch) ||
          normalizedHrStatus.includes(normalizedSearch)
        );
      });
    }


    if (jobTitle) {
      filtered = filtered.filter((candidate) =>
        candidate.job_title === jobTitle
      );
    }

    if (jobCode) {
      filtered = filtered.filter((candidate) =>
        candidate.job_code.toLowerCase().includes(jobCode.toLowerCase())
      );
    }

    if (clientName) {
      filtered = filtered.filter((candidate) =>
        candidate.client_name?.toLowerCase().includes(clientName.toLowerCase())
      );
    }

    if (candidateStatus) {
      filtered = filtered.filter((candidate) =>
        candidate.candidate_status === candidateStatus
      );
    }

    if (fromDate && toDate) {

      const from = new Date(`${fromDate}T00:00:00`);
      const to = new Date(`${toDate}T23:59:59.999`);

      filtered = filtered.filter(candidate => {
        if (!candidate.assessed_date) return false;

        const candidateDate = new Date(candidate.assessed_date.replace(' ', 'T')); // ✅ Fix here
        return candidateDate >= from && candidateDate <= to;
      });

    }

    setFilteredCandidates(filtered);
    setFilteredCandidates2(filtered);
    setCount(filtered.length);
    setCurrentPage(1);
  };

  const handleRedirect = (candidateId, toHr, hasScores) => {
    const hasValidScore =
      (typeof hasScores === "number" && !isNaN(hasScores)) ||
      hasScores === true;
    if (hasValidScore) {
      if (toHr) {
        navigate(`/candidate-hr-progress/${candidateId}`);
      } else {
        navigate(`/candidate-progress-page/${candidateId}`);
      }
    }
  };

  const handleJobTitleChange = (value) => {
    setInputValue("")
    setFinalOptions(allOptions)
    // setOptions(allOptions)
    setShowJobSelect(false)
    setJobTitleFilter(value);
    localStorage.setItem("jobTitleValue", value)
    applyFilters(searchValue, value, "", clientNameFilter, fromDate, toDate, candidateStatusFilter);
  };

  const handleJobTitleChange1 = (value) => {
    setInputValue("")
    setFinalOptions(allOptions)
    // setOptions(allOptions)
    setJobTitleFilter(value);
    localStorage.setItem("jobTitleValue", value)
    applyFilters(searchValue, value, jobCodeFilter, clientNameFilter, fromDate, toDate, candidateStatusFilter);
  };

  const handleJobCodeChange = (event) => {
    const value = event.target.value;
    localStorage.setItem("jobCodeValue", value)
    setJobCodeFilter(value);
    applyFilters(searchValue, jobTitleFilter, value, clientNameFilter, fromDate, toDate, candidateStatusFilter);
  };

  const handleClientNameChange = (event) => {
    const value = event.target.value;
    localStorage.setItem("clientNameValue", value)
    setClientNameFilter(value);
    applyFilters(searchValue, jobTitleFilter, jobCodeFilter, value, fromDate, toDate, candidateStatusFilter);
  };

  const handleCandidateStatusChange = (event) => {
    const value = event.target.value;
    localStorage.setItem("candidateStatusValue", value)
    setCandidateStatusFilter(value);
    applyFilters(searchValue, jobTitleFilter, jobCodeFilter, clientNameFilter, fromDate, toDate, value);
  };

  const handleFromDate = (event) => {
    const value = event.target.value;
    localStorage.setItem("fromDateValue", value)
    setFromDate(value);
    applyFilters(searchValue, jobTitleFilter, jobCodeFilter, clientNameFilter, value, toDate, candidateStatusFilter);
  }

  const handleToDate = (event) => {
    const value = event.target.value;
    localStorage.setItem("toDateValue", value)
    setToDate(value);
    applyFilters(searchValue, jobTitleFilter, jobCodeFilter, clientNameFilter, fromDate, value, candidateStatusFilter);
  }

  const handleJobPostings = async () => {
    setLoading2(true);
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/api/v1/create-answers`,
        {
          withCredentials: true
        }
      );
      const data = response.data;
      setFilteredCandidates(data.candidates);
      setCandidates(data.candidates);
      setCandidates2(response.data.candidates);
      setCount(data.candidates.length);
      setLoading(false);
      setClientNames(getUniqueClientNames(data.candidates));
      setLoading2(false);
      toast.success("Candidates refreshed.");
    } catch (error) {
      setLoading2(false);
      toast.error("Failed to refresh candidates.");
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const handleReport = (report, jobTitle, candidateId) => {
    setAiReport(
      report || {
        success: false,
        error: "No AI report is available.",
        parameters: [],
        percentage: 0,
      }
    );
    setAiJobTitle(jobTitle);
    setSelectedCandidateId(candidateId);
    setShowReport(true);
  };

  const closeReport = () => {
    if (!retryingAiScore) {
      setShowReport(false);
    }
  };

  const retryAiScore = async () => {
    if (!selectedCandidateId || retryingAiScore) return;

    const confirmed = window.confirm(
      "Retrying will send this candidate's resume and job description to Google Gemini for scoring. Continue?"
    );
    if (!confirmed) return;

    setRetryingAiScore(true);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/retry-ai-score`,
        { candidateId: selectedCandidateId },
        { withCredentials: true }
      );

      setAiReport(response.data.ai_report);
      setInactive((value) => value + 1);
      toast.success(response.data.message || "AI score updated.");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to retry AI score."
      );
    } finally {
      setRetryingAiScore(false);
    }
  };

  const handleReset = () => {
    sortName()
    setSortOn(false)
    setSortOrder("desc")
    setJobCodeFilter("")
    setJobTitleFilter("")
    setClientNameFilter("")
    setCandidateStatusFilter("")
    setFromDate("")
    setToDate("")
    setSearchValue("")

    localStorage.setItem("jobTitleValue", "")
    localStorage.setItem("jobCodeValue", "")
    localStorage.setItem("clientNameValue", "")
    localStorage.setItem("fromDateValue", "")
    localStorage.setItem("toDateValue", "")
    localStorage.setItem("candidateStatusValue", "")

    if (selectRef1.current) selectRef1.current.selectedIndex = 0;
    if (selectRef2.current) selectRef2.current.selectedIndex = 0;
    if (selectRef3.current) selectRef3.current.selectedIndex = 0;
    if (selectRef4.current) selectRef3.current.selectedIndex = 0;
    if (fromDateRef.current) fromDateRef.current.value = '';
    if (toDateRef.current) toDateRef.current.value = '';

    applyFilters("", "", "", "", "", "", "")
  };

  const changeCandidateStatus = async (candidateStatus, candidateId) => {
    try {
      let response = await axios.post(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/change-candidate-status`, { candidateStatus, candidateId },
        {
          withCredentials: true
        })
      setCanStatusObj((prev) => ({
        ...prev,
        [candidateId]: candidateStatus
      }))
      toast.success(response.data.message)
    } catch (error) {
      toast.error(error.response.data.message)
    }
  }

  const handleItemPerPage = (number) => {
    setItemsPerPage(number)
  }

  const handelJobTitleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setInputValue(value);

    const filtered = allOptions.filter(job =>
      job.jobTitle.toLowerCase().includes(value)
    );

    setFinalOptions(filtered);
  };

  return (
    <>
      {showReport ? (
        <div
          className="fixed top-0 z-[99] bg-[#292929A8] bg-opacity-90 w-screen h-screen flex items-start pt-8 sm:pt-12 xl:pt-16 pb-10 justify-center overflow-y-auto"
          onClick={closeReport}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="progress-ai-report-title"
            className="bg-white text-[#5D0E23] w-[80%] px-2 sm:px-3 xl:px-4 py-1 sm:py-2 xl:py-2 rounded-[12px] shadow-lg relative max-h-[85vh] flex flex-col p-for-landscape"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-[2px] sm:mb-1">
              <h2 id="progress-ai-report-title" className="font-semibold text-base sm:text-[18px] xl:text-[20px] 2xl:text-[22px] xxl:text-[24px] leading-none tracking-[0px]  bg-gradient-to-r from-[#3B4FF0] to-[#5D0E23] bg-clip-text text-transparent">
                AI Score Report
              </h2>
              <button type="button" aria-label="Close AI score report" onClick={closeReport}>
                <IoIosClose className="cursor-pointer" size={"2em"} color="#405e5d" />
              </button>
            </div>

            <div className="mb-2 space-y-1 border border-[#5D0E2312] p-1 sm:p-2 xl:p-2 rounded-[6px]  font-semibold text-sm sm:text-[13px] xl:text-[14px] 2xl:text-[15px] xxl:text-[16px] tracking-[0.01em]">
              <p>
                <span className="">Job Title:</span>{" "}
                <span className="font-normal">{aiJobTitle}</span>
              </p>
              <p>
                <span className="">Percentage:</span>{" "}
                <span className="font-normal">{formatAiScore(aiReport)}</span>
              </p>
            </div>

            <h2 className=" font-semibold text-base sm:text-[15px] xl:text-[16px] 2xl:text-[18px] xxl:text-[20px] tracking-[0.01em] sm:px-2 xl:px-2 text-[#86203B]">
              Details {aiReport?.error ? "(Report unavailable)" : null}
            </h2>

            <div className="mt-1 flex-1 space-y-1 overflow-y-auto sm:px-2 xl:px-2 scrollbar text-justify">
              {aiReport?.error ? (
                <p className="font-normal text-[#000000]">{aiReport.error}</p>
              ) : null}
              {aiReport?.parameters?.map((item, index) => (
                <div
                  key={index}
                  className=" font-semibold text-[10px] sm:text-[12px] xl:text-[14px] 2xl:text-[16px] tracking-[0.01em] text-[#86203B] pr-3 sm:pr-2 xl:pr-0"
                >
                  <p>
                    <span className="font-medium">Requirement:</span>{" "}
                    <span className="font-normal text-[#000000]">{item.requirement}</span>
                  </p>
                  <p>
                    <span className="font-medium">Analysis:</span>{" "}
                    <span className="font-normal text-[#000000]">{item.analysis}</span>
                  </p>
                  <p>
                    <span className="font-medium">Score:</span>
                    <span className="font-normal text-[#000000]">{item.score}%</span>
                  </p>
                </div>
              ))}
            </div>
            {aiReport?.error ? (
              <div className="flex flex-col items-end gap-1 px-2 pt-3">
                <button
                  type="button"
                  onClick={retryAiScore}
                  disabled={retryingAiScore || !selectedCandidateId}
                  className="min-w-[138px] rounded-md bg-[#86203B] px-4 py-2 text-sm font-semibold text-white hover:bg-[#5D0E23] disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {retryingAiScore ? (
                    <ClipLoader color="white" size={"1em"} />
                  ) : (
                    "Retry AI Score"
                  )}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
      <div className="sm:px-1 lg:px-0 sm:pr-0 xl:px-4 2xl:px-15 mt-[346px] sm:mt-[131px]  lg:mt-[131px] xl:mt-[155px] 2xl:mt-[176px]">
        <div className="fixed top-0 left-0 w-full z-50 bg-white px-3 sm:px-3 sm:pr-0 xl:pr-4 xl:px-4 2xl:px-15 xxl:px-16 py-1 sm:py-2 2xl:py-3">
          <header className="sm:pr-3 xl:pr-0">
            <Top currentUser={currentUser} />
            <Navbar currentUser={currentUser} />
          </header>
          <section className="px-3 pl-0 pr-0 sm:px-3 sm:pr-0 xl:px-0 mx-auto flex flex-col mt-1">
            {!loading3 && !loading2 && !loading ? <div className="overflow-x-auto hide-scrollbar flex flex-col items-start sm:items-end sm:flex-row xl:flex-row gap-1 sm:gap-1 xl:gap-1 2xl:gap-1 mt-2">
              <div className="relative sm:mt-0 xl:mt-0 border-[0.5px] border-[#86203b] flex items-center rounded-[4px] pl-4 sm:pl-2 h-[29px] sm:h-[46px] w-full sm:min-w-[130px] xl:w-[200px] 2xl:w-[514px] mt-1 text-[12px] sm:pr-6">
                <input
                  aria-label="Search candidates"
                  className="font-medium focus:border-0 placeholder-[#222222] focus:outline-0  w-full"
                  type="text"
                  name=""
                  id=""
                  value={searchValue}
                  onChange={handleSearch}
                  placeholder="Search Here.."
                />
                {searchValue ? <IoIosClose onClick={() => handleSearch2("")} size="2em" color="black" className="absolute top-1/2 -translate-y-1/2 right-1 cursor-pointer" /> : null}
              </div>

              <div className="text-[11px] pr-6  sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] relative sm:static sm:flex-col xl:flex-col  font-sem-['Montserrat'] font-semibold leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-[8px] px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap text-[#5D0E23]"
                  htmlFor="jobRole"
                >
                  Job Title
                </label>

                {showJobSelect && (
                  <div ref={jobTitleSRef} className="jobSelect w-[300px] max-h-[200px] sm:max-h-[482px] mt-[28px] overflow-y-scroll bg-white z-[999] absolute top-0 sm:top-auto flex flex-col border border-gray-400 shadow-lg">
                    <div className="relative">
                      <input
                        onChange={handelJobTitleSearch}
                        value={inputValue}
                        className="py-2 text-black focus:outline-none focus:border-none px-1 w-full pr-6"
                        type="text"
                        placeholder="Search"
                      />
                      {inputValue ? <IoIosClose onClick={() => handleJobTitleChange1("")} size="2em" color="black" className="absolute top-1/2 -translate-y-1/2 right-1 cursor-pointer" /> : null}
                    </div>
                    <p onClick={() => handleJobTitleChange("")} className={`text-black py-[8px] cursor-pointer ${jobTitleFilter === "" ? "bg-[#1967D2] text-white" : "bg-white"} hover:bg-[#1967D2] hover:text-white px-1 `}>All</p>
                    {
                      (finalOptions.slice().sort((a, b) => a.jobTitle.localeCompare(b.jobTitle)).map((job, index) => (
                        <p
                          ref={job.jobTitle === jobTitleFilter ? selectedJobRef : null}
                          onClick={() => handleJobTitleChange(job.jobTitle)}
                          className={`text-black py-[8px] ${job.jobTitle === jobTitleFilter ? "bg-[#1967D2] text-white" : "bg-white"} cursor-pointer hover:bg-[#1967D2] hover:text-white px-1 `}
                          key={index}
                        >
                          {job.jobTitle}
                        </p>
                      )))
                    }
                  </div>
                )}

                <button type="button" ref={jobToggleRef} aria-label="Job title" aria-expanded={showJobSelect} onClick={() => setShowJobSelect((prev) => !prev)} className="cursor-pointer flex justify-between w-full select-none">
                  <p title={jobTitleFilter || "All"} className="text-black whitespace-nowrap overflow-hidden">{jobTitleFilter || "All"}</p>
                  <div className=" pointer-events-none bg-white">
                    <FaChevronDown
                      className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                      color="#87213C"
                    />
                  </div>
                </button>
              </div>

              <div className="pr-6 relative sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] xxl:w-[346px] sm:flex-col xl:flex-col  font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-2 px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap text-[#5D0E23] sm:px-1"
                  htmlFor="jobRole"
                >
                  Job Code
                </label>
                <select
                  ref={selectRef1}
                  id="jobRole"
                  aria-label="Job code"
                  value={jobCodeFilter}
                  onChange={handleJobCodeChange}
                  className="focus:outline-0 appearance-none focus:border-0 w-full cursor-pointer text-[#000000] sm:px-1"
                // value={jobCodeFilter}
                >
                  <option value="">All</option>
                  {
                    jobTitleFilter ? (
                      finalOptions?.filter((job) => job.jobTitle === jobTitleFilter).slice().sort((a, b) => {
                        const numA = parseInt(a.jobCode.match(/\d+/)?.[0] || '0', 10);
                        const numB = parseInt(b.jobCode.match(/\d+/)?.[0] || '0', 10);
                        return numA - numB;
                      })
                        .map((job) => {
                          return <option
                            key={job.id}
                            value={job.jobCode}
                            className={'text-black'}
                          >
                            {job.jobCode}
                          </option>
                        })
                    ) : (
                      finalOptions?.slice().sort((a, b) => {
                        const numA = parseInt(a.jobCode.match(/\d+/)?.[0] || '0', 10);
                        const numB = parseInt(b.jobCode.match(/\d+/)?.[0] || '0', 10);
                        return numA - numB;
                      })
                        .map((job) => {
                          return <option
                            key={job.id}
                            value={job.jobCode}
                            className={'text-black'}
                          >
                            {job.jobCode}
                          </option>
                        })
                    )
                  }
                </select>
                <div className="absolute right-0 sm:top-[70%] xl:top-[70%] top-1/2 -translate-y-1/2 pointer-events-none bg-white pr-2">
                  <FaChevronDown
                    className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                    color="#87213C"
                  />
                </div>
              </div>

              <div className="pr-6 relative sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] xxl:w-[346px] sm:flex-col xl:flex-col  font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-2 px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap text-[#5D0E23] sm:px-1"
                  htmlFor="clientName"
                >
                  Client Name
                </label>
                <select
                  ref={selectRef3}
                  id="clientName"
                  aria-label="Client name"
                  onChange={handleClientNameChange}
                  className="focus:outline-0 appearance-none focus:border-0 w-full cursor-pointer text-[#000000] sm:px-1"
                  value={clientNameFilter}
                  title={clientNameFilter}
                >
                  <option value="">All</option>
                  {clientNames
                    ?.slice() // make a copy to avoid mutating the original array
                    .sort((a, b) => a.localeCompare(b)) // sort alphabetically
                    .map((clientName, index) => (
                      <option
                        className="text-black"
                        key={index}
                        value={clientName}
                      >
                        {clientName}
                      </option>
                    ))}
                </select>
                <div className="absolute right-0 sm:top-[70%] xl:top-[70%] top-1/2 -translate-y-1/2 pointer-events-none bg-white pr-2">
                  <FaChevronDown
                    className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                    color="#87213C"
                  />
                </div>
              </div>
              <div className="pr-6 relative sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] xxl:w-[346px] sm:flex-col xl:flex-col  font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-2 px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap text-[#5D0E23] sm:px-1"
                  htmlFor="clientName"
                >
                  Candidate Status
                </label>
                <select
                  ref={selectRef4}
                  id="candidateStatus"
                  aria-label="Candidate status"
                  onChange={handleCandidateStatusChange}
                  className="focus:outline-0 appearance-none focus:border-0 w-full cursor-pointer text-[#000000] sm:px-1"
                  value={candidateStatusFilter}
                >
                  <option value="">All</option>
                  <option value="open">Open</option>
                  <option value="accepted">Accepted</option>
                  <option value="rejected">Rejected</option>
                </select>
                <div className="absolute right-0 sm:top-[70%] xl:top-[70%] top-1/2 -translate-y-1/2 pointer-events-none bg-white pr-2">
                  <FaChevronDown
                    className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                    color="#87213C"
                  />
                </div>
              </div>
              <div className="pr-6 relative sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] sm:flex-col xl:flex-col  font-sem-['Montserrat'] font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-[10px] px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-1 sm:gap-[2px]">
                <label
                  className="whitespace-nowrap text-[#5D0E23]"
                  htmlFor="jobRole"
                >
                  From
                </label>

                <div className="flex flex-col  text-black items-start">
                  <div className="flex gap-1 items-center ">
                    <p className="">{fromDate || "YYYY/MM/DD"}</p>
                    <input ref={fromDateRef} aria-label="From date" value={fromDate} onChange={handleFromDate} className="hide-date hidden-date-input" type="date" max={toDate || today} />
                    <SlCalender onClick={handleFromDateClick} size={"1em"} className="cursor-pointer " />
                  </div>
                </div>
              </div>
              <div className="pr-6 relative sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] sm:flex-col xl:flex-col  font-sem-['Montserrat'] font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-[10px] px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-1 sm:gap-[2px]">
                <label
                  className="whitespace-nowrap text-[#5D0E23]"
                  htmlFor="jobRole"
                >
                  To
                </label>

                <div className="flex flex-col  text-black items-start">
                  <div className="flex gap-1 items-center ">
                    <p className="">{toDate || "YYYY/MM/DD"}</p>
                    <input ref={toDateRef} aria-label="To date" value={toDate} onChange={handleToDate} className="hide-date  hidden-date-input" type="date" max={today} min={fromDate} />
                    <SlCalender onClick={handleToDateClick} size={"1em"} className="cursor-pointer " />
                  </div>
                </div>
              </div>
              <div className="flex gap-1">
                <button
                  title="Clear Filters"
                  onClick={handleReset}
                  className="bg-[#87213C] text-[#ffffff] flex self-start sm:self-end p-[7px] sm:h-[46px] sm:min-w-[46px] sm:max-w-[46px] rounded-[6px] items-center justify-center cursor-pointer text-xs"
                >
                  Reset
                </button>
                <button
                  type="button"
                  aria-label="Refresh candidates"
                  title="Refresh Candidates"
                  disabled={loading2}
                  onClick={handleJobPostings}
                  className="bg-[#87213C] text-[#ffffff] flex self-start sm:self-end h-[30px] w-[30px]  sm:h-[46px] sm:min-w-[46px] sm:max-w-[46px] rounded-[6px] items-center justify-center cursor-pointer"
                >
                  {!loading2 ? (
                    <div className="flex gap-2 cursor-pointer">
                      <IoReload color="#ffffff" size={"1.2em"} />
                    </div>
                  ) : (
                    <ClipLoader color="#ffffff" size={"1em"} />
                  )}
                </button>

              </div>
            </div> : <div>
              <div className="flex flex-col space-x-4 sm:hidden">
                {Array(8).fill().map((_, i) => (
                  <Skeleton key={i} height={30} />
                ))}
              </div>
              <div className="space-x-4 overflow-hidden hidden sm:flex">
                {Array(18).fill().map((_, i) => (
                  <Skeleton key={i} height={46} width={180} />
                ))}
              </div>
            </div>}
          </section>
        </div>
        <main>
          <section>
            <div className="mt-3 overflow-auto hide-scrollbar px-3 sm:px-4 pr-0 sm:pr-0 xl:px-0">
              <div className="relative">
                <div className="c-table-div overflow-auto hide-scrollbar xl:scrollbar">
                  <table className="border-collapse xl:w-full w-[1200px]">
                    <thead className="bg-[#87213C] text-white font-semibold text-[12px] leading-none tracking-[0px] px-10 sticky top-0 z-10">
                      <tr className="text-[10px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] xxl:text-[16px] font-semibold leading-none tracking-[0px] ">
                        <th className="whitespace-nowrap text-left px-4 pr-0 py-[3px] sm:py-1 xl:py-1 2xl:py-2 xxl:py-6 rounded-tl-[6px] rounded-bl-[6px]">
                          Name / <br /> Email
                        </th>
                        <th className="whitespace-nowrap text-left px-4 pr-0 ">
                          Job Title / <br /> Client Name
                        </th>
                        <th className="text-left px-4 pr-0">
                          <span className="whitespace-nowrap">JobCode /<br />Applicant ID</span>
                        </th>
                        <th onClick={sortScores} className="whitespace-nowrap text-left px-4 pr-0 cursor-pointer select-none">
                          <div className="flex items-center gap-2">
                            PowerHires <br /> Scores
                            {sortOrder === "desc" ? <FaLongArrowAltUp color={sortOn ? "#ffffff" : "#ffffff50"} /> : <FaLongArrowAltDown color={sortOn ? "#ffffff" : "#ffffff50"} />}
                          </div>
                        </th>
                        <th className="whitespace-nowrap text-left px-4 pr-0 ">
                          Skill Assessment <br /> Score
                        </th>
                        <th className="whitespace-nowrap text-left px-4 pr-0">
                          HR <br /> Assessment
                        </th>
                        <th className="whitespace-nowrap text-left px-4 pr-0 ">
                          Assessment <br /> Given Date
                        </th>
                        <th className="whitespace-nowrap text-left px-4 pr-0  rounded-tr-[6px] rounded-br-[6px]">
                          Candidate <br /> Status
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading || loading2 || loading3 ? (
                        <tr>
                          <td
                            colSpan="11"
                            className={`text-start sm:text-center p-5 `}
                          >
                            <ClipLoader color="#9a3257" size={30} />
                          </td>
                        </tr>
                      ) : (
                        paginatedCandidates.length < 1 ? <tr>
                          <td
                            colSpan="11"
                            className={`text-start sm:text-center p-5 `}
                          >
                            <h2 className="">No recors found.</h2>
                          </td>
                        </tr> : paginatedCandidates.map((candidate, index) => (
                          <tr
                            key={index}
                            data-candidate-id={candidate.candidate_id}
                            className=" bg-white hover:bg-[#F5F5F5] text-[11px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px]  border-b border-[#EDEDED] align-center font-medium leading-none tracking-[0px] "
                          >
                            <td
                              className="cursor-pointer px-4 pr-0 py-2 text-left"
                            >
                              <span className=" sm:text-[11px] xl:text-[12px] 2xl:text-[13px] font-normal xxl:text-[14px] leading-none tracking-[0px] ">
                                {candidate.name}
                              </span>
                              <span className="block mt-[2px] sm:mt-[3px] xl:mt-[3px] 2xl:mt-[4px] font-medium  text-[11px]">
                                {candidate.email}
                              </span>
                            </td>
                            <td
                              className="px-4 pr-0 py-2 text-left"
                            >
                              <span className=" text-[11px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] font-normal leading-none tracking-[0px] ">
                                {candidate.job_title}
                              </span>
                              <span className="block mt-[2px] sm:mt-[3px] xl:mt-[3px] 2xl:mt-[4px] font-medium  ">
                                {candidate.client_name}
                              </span>
                            </td>
                            <td className="px-4 pr-0 py-2 text-left">
                              <span className="text-[#000000] font-normal text-[11px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] leading-none tracking-[0px] ">
                                {candidate.job_code}
                              </span>
                              <span className="block text-[11px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] mt-[2px] sm:mt-[3px] xl:mt-[3px] 2xl:mt-[4px] font-medium text-[#000000]">
                                {candidate.applicant_id}
                              </span>
                            </td>
                            <td
                              className="whitespace-nowrap cursor-pointer px-4 pr-0 py-2 text-left"
                            >
                              <div>
                                <button
                                  type="button"
                                  aria-label={`Open AI score report for ${candidate.name}`}
                                  onClick={() =>
                                    handleReport(
                                      candidate.ai_report,
                                      candidate.job_title,
                                      candidate.candidate_id
                                    )
                                  }
                                  className="rounded-[8px] p-2 text-left w-fit underline text-[#3B4FF0] cursor-pointer"
                                >
                                  {formatAiScore(candidate.ai_report)}
                                </button>
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-4 pr-0 py-2 text-left">
                              <button
                                type="button"
                                aria-label={`Open skill result for ${candidate.name}`}
                                disabled={typeof candidate.assessment_score !== "number" || isNaN(candidate.assessment_score)}
                                onClick={() => handleRedirect(candidate.candidate_id, false, candidate.assessment_score)}
                                className="w-full text-left disabled:cursor-default"
                              >
                              {typeof candidate.assessment_score === "number" &&
                                !isNaN(candidate.assessment_score) ? (
                                <div>
                                  <p>{candidate.assessment_score}%</p>
                                  <div className="sm:w-[150px] xl:w-[180px] 2xl:[210px] xxl:w-[237px] h-[8px] relative pt-2">
                                    <div className="absolute rounded-[100px] bg-[#e4e4e4] sm:w-[150px] xl:w-[180px] 2xl:[210px] xxl:w-[237px] h-[8px]"></div>
                                    <div
                                      className={`absolute rounded-[100px] h-[8px] ${candidate.assessment_score >= filterThresholds.green
                                        ? "bg-[#129924]"
                                        : candidate.assessment_score >= filterThresholds.amber
                                          ? "bg-[#F7BF24]"
                                          : "bg-[#FF595C]"
                                        }`}
                                      style={{
                                        width: `${candidate.assessment_score}%`,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              ) : (
                                candidate.hr_status === "pass" ? "Unattempted" : "N/A"
                              )}
                              </button>
                            </td>
                            <td className={`whitespace-nowrap px-4 pr-0 py-2 text-left ${candidate.hr_status === "pass" ? "text-[#129924]" : "text-[#FF595C]"}`}>
                              <button
                                type="button"
                                aria-label={`Open HR result for ${candidate.name}`}
                                disabled={!candidate.hr_status}
                                onClick={() => handleRedirect(candidate.candidate_id, true, true)}
                                className="disabled:cursor-default enabled:hover:text-blue-500 enabled:hover:underline"
                              >
                                {(candidate.hr_status || "N/A")
                                  .charAt(0)
                                  .toUpperCase() +
                                  (candidate.hr_status || "N/A").slice(1)}
                              </button>
                            </td>
                            <td
                              className="whitespace-nowrap px-4 pr-0 py-2 text-left"
                            >
                              {candidate.assessed_date?.split("T")[0]}
                            </td>
                            <td
                              className="whitespace-nowrap px-4 pr-0 py-2 text-left"
                            >
                              <select aria-label={`Candidate status for ${candidate.name}`} onChange={(event) => changeCandidateStatus(event.target.value, candidate.candidate_id)} value={canStatusObj[candidate.candidate_id] || candidate.candidate_status} name="" id="" className="focus:outline-none">
                                <option value="open">Open</option>
                                <option value="accepted">Accept</option>
                                <option value="rejected">Reject</option>
                              </select>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
          <div className="flex flex-col sm:flex sm:flex-row sm:justify-between sm:items-center">
            {!loading3 && filterThresholds ? <div className="absolute bottom-2 sm:bottom-2 left-1/2 -translate-x-1/2 sm:-translate-x-0 sm:left-5 xl:left-6 flex text-xs gap-2 border border-[#908B8C] rounded-[6px] p-[6px]">
              <div className="flex items-center gap-1">
                <div className="bg-[#129924] h-3 w-3 rounded-full"></div>
                <div className="flex items-center gap-[4px]">
                  <p>Pass</p>
                  <FaGreaterThanEqual size={"0.8em"} />
                  <p>{filterThresholds.green}%</p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div className="bg-[#F7BF24] h-3 w-3 rounded-full"></div>
                <div className="flex items-center gap-[4px]">
                  <p>Pending</p>
                  <p>{filterThresholds.amber}%</p>
                  <FiMinus size={"0.8em"} />
                  <p>{filterThresholds.green - 1}%</p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div className="bg-[#FF595C] h-3 w-3 rounded-full"></div>
                <div className="flex items-center gap-[4px]">
                  <p>Fail</p>
                  <FaLessThan size={"0.8em"} />
                  <p>{filterThresholds.amber}%</p>
                </div>
              </div>
            </div> : null}
            <div className="absolute bottom-11 sm:bottom-2 right-2 sm:right-3 xl:right-4 text-[10px] sm:text-xs flex items-center justify-center sm:justify-end xl:justify-end text-center mt-2 font-semibold  leading-none tracking-[0%]  w-full">
              <p className="pr-1 sm:pr-2 text-xs">Total {candidateStatusFilter ? `(${candidateStatusFilter?.slice(0, 1).toUpperCase() + candidateStatusFilter.slice(1)})` : ""}: {count}</p>
              <div className="border border-[#908B8C]  flex w-[94px] sm:w-[124px] h-[30px] rounded-[6px] items-center justify-center sm:gap-2 self-end">
                <p className="text-[10px] sm:text-xs">Per Page</p>
                <select
                  value={itemsPerPage}
                  className="cursor-pointer focus:outline-none focus:outline-n"
                  onChange={(e) => handleItemPerPage(Number(e.target.value))}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div className="flex flex-wrap">
                <button
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                  className={`sm:mx-1 px-1 sm:px-3 py-1 rounded-md ${currentPage === 1
                    ? "text-[#CCCCCC]"
                    : "text-[#000000]"
                    }`}
                >
                  Prev
                </button>

                <div className="w-fit">
                  {getPageNumbers().map((page, idx) => (
                    <button
                      key={idx}
                      onClick={() => page !== "..." && handlePageChange(page)}
                      className={`mx-1 ${page === "..." ? "cursor-default" : "cursor-pointer"} py-1 h-[18px] w-[18px] sm:h-[28px] sm:w-[28px] rounded-md ${page === "..."
                        ? "bg-white text-[#000000] cursor-default"
                        : currentPage === page
                          ? "bg-[#5D0E23] text-white"
                          : "bg-white border text-[#000000] border-[#F1F1F1]"
                        }`}
                      disabled={page === "..."}
                    >
                      {page}
                    </button>
                  ))}
                </div>

                <button
                  disabled={currentPage === totalPages || count === 0}
                  onClick={() => handlePageChange(currentPage + 1)}
                  className={`sm:mx-1 px-1 sm:px-3 py-1 rounded-md  ${currentPage === totalPages || count === 0
                    ? "text-[#cccccc]"
                    : "text-[#000000]"
                    }`}
                >
                  Next
                </button></div>
            </div>
          </div>

        </main>
      </div>
    </>
  );
};

export default CandidateProgressDashboard;
